import React, { useState } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { Button } from '../../../Components/MUIs';
import BottomSheet from '../../../Components/Ui/BottomSheet';
import Canvas from '../../../Components/Canvas/Canvas';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { useSelector } from 'react-redux';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';

export default function SignBottomSheet({
  onComplete,
  Save1,
  signatureCanvas,
  setMode,
}) {
  const dispatch = useDispatch();
  const { baseInfo } = useSelector((state) => state.permit);
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const [signInputs, setSignInputs] = useState({
    mapUrl: '',
    mapFiles: {},
  }); // 서명 state

  const handleComplete = async () => {
    if (!signInputs.mapUrl) {
      dispatch(
        showSnackbar({ message: '서명을 완료해주세요.', type: 'warning' })
      );
      return;
    }

    // --- [로그 시작] 현재 데이터 상태 확인 ---
    console.log('로그인 유저 ID:', userInfo.decUserId);
    console.log('지정된 안전관리자(SM) ID:', baseInfo.safetyApproverId);
    console.log('결재자 리스트(approverList):', baseInfo.approverList);
    // ---------------------------------------

    let gubun = '1'; // 기본값: 부서장(DEP)

    // 1. 내가 안전관리자(SM)로 지정되어 있는지 확인
    const isIAmSafetyApprover =
      baseInfo.safetyApproverId === userInfo.decUserId;

    // 2. 내가 부서장으로서 서명을 이미 완료했는지 확인
    // approverList에서 내 ID를 찾고, signaturePath가 실제로 존재하는지 체크
    const myDepSign = baseInfo.approverList?.find(
      (a) => String(a.approverId) === String(userInfo.decUserId)
    );

    // 만약 내가 부서장 결재라인에 아예 없다면(myDepSign이 undefined), 부서장 단계는 건너뛴 것으로 간주
    const isDepSignDone = myDepSign
      ? myDepSign.signaturePath && myDepSign.signaturePath !== ''
      : true;

    console.log('내가 안전관리자인가?:', isIAmSafetyApprover);
    console.log('나의 부서장 서명이 완료되었는가?:', isDepSignDone);

    if (isIAmSafetyApprover) {
      if (isDepSignDone) {
        gubun = '2'; // 부서장 서명이 끝났으니 이제 안전관리자(SM) 서명으로 전송
      } else {
        gubun = '1'; // 아직 부서장 서명 안했으니 부서장(DEP) 서명으로 전송
      }
    } else {
      gubun = '1'; // 안전관리자가 아니라면 무조건 부서장 서명
    }

    // --- [최종 로그] 서버로 보내기 직전 gubun 확인 ---
    console.log('🚀 최종 전송 gubun 값:', gubun);
    // ----------------------------------------------

    // Mode 설정
    if (gubun === '2') setMode('signSm');
    else setMode('signDep');

    // 서버 저장 호출
    try {
      await Save1({ gubun: gubun, signFile: signInputs.mapFiles });
      dispatch(BottomSheetActions.CloseBottomSheet());
      onComplete();
    } catch (error) {
      console.error('저장 중 오류 발생:', error);
    }
  };

  return (
    <BottomSheet
      isHeaderChildren={true}
      headerText={''}
      headerChildren={
        <Typography
          sx={{
            fontSize: '18px',
            fontWeight: 'bold',
            display: 'flex',
            flexWrap: 'wrap', // 줄바꿈 허용
            lineHeight: 1.4,
          }}
        >
          {baseInfo.name}님의 작업허가서를&nbsp;
          <span style={{ color: '#57B84D' }}>승인</span>
          합니다.
        </Typography>
      }
    >
      <Box sx={{ px: 1 }}>
        <Typography style={{ color: '#918A8A', paddingBottom: '0.5rem' }}>
          서명해주세요.
        </Typography>
        {/* <Box>
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 'bold',
              display: 'flex',
            }}
          >
            작업관리 부서
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 1 }}>
            <Checkbox
              name={'현장 확인 결과 이상없음'}
              checked={agree.check1}
              onChange={(checked) => setAgree({ ...agree, check1: checked })}
              sx={{ padding: '0px 8px ' }}
            />
            <Checkbox
              name={'보완 사항 보완 후 작업'}
              checked={agree.check2}
              onChange={(checked) => setAgree({ ...agree, check2: checked })}
              sx={{ padding: '0px 8px ' }}
            />
          </Box>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            type="text"
            style={{
              width: '100%',
              padding: '14px 16px',
              borderRadius: '8px',
              outline: 'none',
              fontSize: '14px',
              backgroundColor: '#F8F8F8',
              border: 'none',
              transition: 'border-color 0.3s ease',
              minHeight: '10rem',
              resize: 'none',
              boxSizing: 'border-box',
            }}
            placeholder="내용을 작성해주세요."
          />
        </Box> */}

        {/* 서명 영역 */}
        <Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>
              서명
            </Typography>
            <Chip
              sx={{ borderRadius: '8px' }}
              label="재설정"
              size="small"
              variant="outlined"
              onClick={() => {
                signatureCanvas.current.clear();
                setSignInputs({ mapUrl: '', mapFiles: {} });
              }}
            />
          </Box>
          <Box sx={{ pt: 1 }}>
            <Canvas
              signatureCanvas={signatureCanvas}
              userId={userInfo.userNm}
              imageUrl={signInputs.mapUrl}
              onEnd={() => {
                const dataURL = signatureCanvas.current.toDataURL('image/png');
                const decodedData = atob(dataURL.split(',')[1]);
                const byteNumbers = new Array(decodedData.length);
                for (let i = 0; i < decodedData.length; i++) {
                  byteNumbers[i] = decodedData.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'image/png' });

                setSignInputs({
                  mapUrl: dataURL,
                  mapFiles: new File(
                    [blob],
                    `${new Date()
                      .toISOString()
                      .replace(/T/, '')
                      .replace(/\..+/, '')
                      .replace(/-/g, '')
                      .replace(/:/g, '')}.png`,
                    { type: 'image/png' }
                  ),
                });
              }}
            />
          </Box>
        </Box>
      </Box>
      <Box
        p={1}
        bgcolor="#fff"
        sx={{
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Button
          name="완료"
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: '#57B84D',
            color: '#fff',
            boxShadow: 'none',
          }}
          onClick={handleComplete}
        />
      </Box>
    </BottomSheet>
  );
}
